import { FieldProps } from "forms/form.types";
import Dropdown from "../Dropdown";
import FileInput from "../FileInput";
import TextArea from "../TextArea";
import TextField from "../TextField";
import EmailField from "../EmailField";
import PhoneField from "../PhoneField";
import RFCField from "../RFCField";
import CURPField from "../CURPField";
import ZipCodeField from "../ZipCodeField";
import PasswordField from "../PasswordField";
import MapField from "../MapField";
import CheckboxField from "../CheckboxField";
import styles from "./Field.module.scss";

const Field: React.FC<FieldProps> = ({
  name,
  label,
  value,
  type,
  required,
  placeholder,
  disabled,
  options,
  validateDomain,
  validateItIsNewDataMessage,
  apiCall,
  errorMessage,
  fieldCaption,
  needsValidationFrom,
  needsToBeDifferentfrom,
  children,
  dynamicOptionsProp,
  optionsContext,
  maxLength,
  size = "full-width",
}) => {
  const props = {
    name,
    label,
    value,
    type,
    required,
    placeholder,
    disabled,
    options,
    validateDomain,
    validateItIsNewDataMessage,
    apiCall,
    errorMessage,
    fieldCaption,
    needsValidationFrom,
    needsToBeDifferentfrom,
    children,
    dynamicOptionsProp,
    optionsContext,
    maxLength,
  };

  return (
    <div className={`${styles["field-container"]} ${styles[size]}`}>
      {
        {
          text: <TextField {...props} />,
          number: <TextField {...props} />,
          rfc: <RFCField {...props} />,
          curp: <CURPField {...props} />,
          zipcode: <ZipCodeField {...props} />,
          tel: <PhoneField {...props} />,
          email: <EmailField {...props} />,
          password: <PasswordField {...props} />,
          textarea: <TextArea {...props} />,
          dropdown: <Dropdown {...props} />,
          file: <FileInput {...props} />,
          map: <MapField {...props} />,
          checkbox: <CheckboxField {...props} />,
        }[type]
      }
    </div>
  );
};

export default Field;
